import {
    BUYER_DASHBOARD_FETCH,
    BUYER_DASHBOARD_FETCH_COMPLETED,
    BUYER_DASHBOARD_RETAIL_INTEGRATIONS_PANEL_SET,
    BUYER_SETUP_GUIDE,
} from "constants/action-types";

export const fetchDashboard = () => ({ type: BUYER_DASHBOARD_FETCH });
export const fetchDashboardSuccess = (payload) => ({
    payload,
    type: BUYER_DASHBOARD_FETCH_COMPLETED,
});
export const fetchDashboardError = (payload, error) => ({
    payload,
    error,
    type: BUYER_DASHBOARD_FETCH_COMPLETED,
});

export const fetchSetupGuide = () => ({ type: BUYER_SETUP_GUIDE.FETCH.START });

export const dismissSetupGuideTasks = (tasks) => ({ type: BUYER_SETUP_GUIDE.DISMISS.START, payload: tasks });

export const setShowRetailIntegrationsPanel = (show) => ({
    type: BUYER_DASHBOARD_RETAIL_INTEGRATIONS_PANEL_SET,
    payload: show,
});
